import React from 'react';

export default function PwInstructionList({ isMobile = true }) {
	if (isMobile) {
		return (
			<ul className="p-i">
				<li>Your password should contain at least:</li>
				<li>8 characters</li>
				<li>1 special character</li>
				<li>1 number</li>
			</ul>
		);
	}

	return null;
}
